import React from 'react'
import "./Loader.css"

const Loader = () => {
  return (
    <div id='loader' className='loading'></div>
  )
}

export default Loader